export default __webpack_public_path__ + "static/media/sqlserver.d4f90b22.png";